'use client';

import Modal from "./Modal";
import useSearchModal, { SearchQuery } from "@/app/hooks/useSearchModal";
import DatePicker, { DateRangeType } from "../forms/Calendar";
import SelectCountry, { SelectCountryValue } from "../forms/SelectCountry";
import { useState } from "react";
import CustomButton from "../forms/CustomButton";

const SearchModal = () => {
    const searchModal = useSearchModal();

    const [numDays, setNumDays] = useState<string>('1');
    const [country, setCountry] = useState<SelectCountryValue>();
    const [dateRange, setDateRange] = useState<DateRangeType>({
        startDate: new Date(),
        endDate: new Date(),
    });

    // Função para setar o intervalo de datas
    const _setDateRange = (range: DateRangeType) => {
        if (searchModal.step === 'checkin') {
            searchModal.open('checkout');
        } else if (searchModal.step === 'checkout') {
            searchModal.open('details');
        }

        setDateRange(range);
    };

    // Função para buscar e fechar o modal
    const closeAndSearch = () => {
        const newSearchQuery: SearchQuery = {
            country: country?.label,
            checkIn: dateRange.startDate,
            checkOut: dateRange.endDate,
            days: parseInt(numDays),
            category: '',
        };

        searchModal.setQuery(newSearchQuery);
        searchModal.close();
    };

    // Conteúdos dos passos
    const contentLocation = (
        <>
            <h2 className="mb-6 text-2xl">Selecione um país</h2>

            <SelectCountry 
                value={country}
                onChange={(value) => setCountry(value as SelectCountryValue)}
            />

            <div className="mt-6 flex flex-row gap-4">
                <CustomButton 
                    label="Data de entrada →"
                    onClick={() => searchModal.open('checkin')}
                    className="w-full py-4 bg-nat-reggaex hover:bg-nat-reggaex-dark text-white text-center rounded-xl transition cursor-pointer"
                />
            </div>
        </>
    );

    const contentCheckin = (
        <>
            <h2 className="mb-6 text-2xl">Dia do show</h2>

            <DatePicker 
                value={dateRange}
                onChange={_setDateRange}
            />

            <div className="mt-6 flex flex-row gap-4">
                <CustomButton 
                    label="← Localização"
                    onClick={() => searchModal.open('location')}
                    className="w-full py-4 bg-nat-reggaex hover:bg-nat-reggaex-dark text-white text-center rounded-xl transition cursor-pointer"
                />

                <CustomButton 
                    label="Data de saída →"
                    onClick={() => searchModal.open('checkout')}
                    className="w-full py-4 bg-nat-reggaex hover:bg-nat-reggaex-dark text-white text-center rounded-xl transition cursor-pointer"
                />
            </div>
        </>
    );

    const contentCheckout = (
        <>
            <h2 className="mb-6 text-2xl">Mais de um dia de show?</h2>

            <DatePicker 
                value={dateRange}
                onChange={_setDateRange}
            />

            <div className="mt-6 flex flex-row gap-4">
                <CustomButton 
                    label="← Data de entrada"
                    onClick={() => searchModal.open('checkin')}
                    className="w-full py-4 bg-nat-reggaex hover:bg-nat-reggaex-dark text-white text-center rounded-xl transition cursor-pointer"
                />

                <CustomButton 
                    label="Detalhes →"
                    onClick={() => searchModal.open('details')}
                    className="w-full py-4 bg-nat-reggaex hover:bg-nat-reggaex-dark text-white text-center rounded-xl transition cursor-pointer"
                />
            </div>
        </>
    );

    const contentDetails = (
        <>
            <h2 className="mb-6 text-2xl">Total de dias</h2>

            <div className="space-y-4">
                <div className="space-y-4">
                    <label>Quantos dias?</label>
                    <input 
                        type="number" 
                        min="1" 
                        value={numDays} 
                        onChange={(e) => setNumDays(e.target.value)}
                        className="w-full h-14 px-4 border border-gray-300 rounded-xl"
                    />
                </div>
            </div>

            <div className="mt-6 flex flex-row gap-4">
                <CustomButton 
                    label="← Data de saída"
                    onClick={() => searchModal.open('checkout')}
                    className="w-full py-4 bg-nat-reggaex hover:bg-nat-reggaex-dark text-white text-center rounded-xl transition cursor-pointer"
                />

                <CustomButton 
                    label="✔ Buscar"
                    onClick={closeAndSearch}
                    className="w-full py-4 bg-nat-reggaex hover:bg-nat-reggaex-dark text-white text-center rounded-xl transition cursor-pointer"
                />
            </div>
        </>
    );

    // Definição de qual conteúdo exibir
    let content = <></>;
    if (searchModal.step === 'location') {
        content = contentLocation;
    } else if (searchModal.step === 'checkin') {
        content = contentCheckin;
    } else if (searchModal.step === 'checkout') {
        content = contentCheckout;
    } else if (searchModal.step === 'details') {
        content = contentDetails;
    }

    return (
        <Modal             
            label="Pesquisa"
            content={content}
            close={searchModal.close}
            isOpen={searchModal.isOpen}
        />
    );
};

export default SearchModal;
